import React from "react";
import { useHistory } from 'react-router-dom';
import { WizardChat } from "components/util/helpers/Wizard";
import { Loading } from "seed/helpers";
import l from "components/util/l"

const ActionsWizardView = ({
  flow,
  studioRef,
  parentProcessNode,
  isWizardAssistant,
  wizardFlow,
  reloadFlow,
}) => {

  const historyRouter = useHistory();
  

  let shoudRender = true;
  if (isWizardAssistant) {
    if (!wizardFlow?.flow?.id)
      shoudRender = false;
  }

  if (!shoudRender)
    return <Loading />;

  const mainProcessName = wizardFlow?.parent_node?.id ? "CREATE_SUBPROCESS" : "CREATE_PROCESS";
  const subtitle = wizardFlow?.parent_node?.id ? l("Continuar proceso%SA252") + ` (${parentProcessNode?.rootName})` : l("Crear proceso%SA244");

  return <WizardChat
    flow={flow}
    mainProcessName={mainProcessName}
    params={{
      flow_id: wizardFlow?.flow?.id,
      parent_id: wizardFlow?.parent_node?.id,
    }}
    subtitle={subtitle}
    hideTitle={true}
    onWizardMessage={(msg) => {
      studioRef?.current?.reloadFlow()
    }}
    onCompleted={(data) => {
      reloadFlow();
      historyRouter.replace(`/flow`);
    }}
    onAborted={() => {
      console.log("Wizard aborted");
    }}
  />;

}

export default ActionsWizardView;